<div class="fullcontainer" >
    <br />
    <br />

    <div class='titleContainer'>
      <h2 class='header' style='color: #006498'>Select a Company</h2>
      <div>
        <button class='btn btn-secondary' routerLink='/contract'><i class="fas fa-arrow-left"></i> Back</button>
      </div>
    </div>
    <br />
    <br />
    <app-grid
  entity='account'
  [filters]='this.filters'
  [columns]='this.columns'
  [buttons]='this.buttons'
  [searchFilters]='this.searchFilters'
  [searchFields]='this.searchFields'
  ></app-grid>
